import styled from 'styled-components';

export const CardContainer = styled.div`
  flex: 1;
`;
